import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    [theme.breakpoints.up("lg")]: {
      gap: theme.spacing(3.5),
    },
  },
  text: {
    fontSize: "0.56rem",
    fontWeight: 500,
    color: "#767676",
    [theme.breakpoints.up("lg")]: {
      fontSize: "0.75rem",
    },
  },
}));
